export enum NoticeType {
  SUCCESS = 'success',
  SUPER_SUCCESS = 'super_success',
  SUPER_INFO = 'super_info',
  WARNING = 'warning',
  SUPER_WARNING = 'super_warning',
  ERROR = 'error',
  SUPER_ERROR = 'super_error',
  WAIT = 'wait',
}

export enum UiKitIcons {
  SUCCESS = 'icon-80/Success',
  SUPER_SUCCESS = 'icon-80/SuperSuccess',
  SUPER_INFO = 'icon-80/SuperInfo',
  WARNING = 'icon-80/Warning',
  SUPER_WARNING = 'icon-80/SuperWarning',
  ERROR = 'icon-80/Fail',
  SUPER_ERROR = 'icon-80/SuperFail',
  WAIT = 'icon-80/Wait',
}

export const noticeErrorTypeMapping = {
  [NoticeType.SUCCESS]: UiKitIcons.SUCCESS,
  [NoticeType.SUPER_SUCCESS]: UiKitIcons.SUPER_SUCCESS,
  [NoticeType.SUPER_INFO]: UiKitIcons.SUPER_INFO,
  [NoticeType.WARNING]: UiKitIcons.WARNING,
  [NoticeType.SUPER_WARNING]: UiKitIcons.SUPER_WARNING,
  [NoticeType.ERROR]: UiKitIcons.ERROR,
  [NoticeType.SUPER_ERROR]: UiKitIcons.SUPER_ERROR,
  [NoticeType.WAIT]: UiKitIcons.WAIT,
}
